export default __webpack_public_path__ + "static/media/ic_stats.276e5aa0.svg";